const api = {
  GET_LIST_HISTORY_INSERT_TRANSACTION: '/index.php?r=api/v1/maintenance_transaction/maintenance-transaction/index',
  GET_DETAIL_HISTORY_INSERT_TRANSACTION: '/index.php?r=api/v1/maintenance_transaction/maintenance-transaction/detail',
};

export default api;
